import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { DetalleTareaService } from 'app/modules/admin/detalle-tareas/detalle-tareas-service';
import { UtilsService } from 'app/modules/utils-service';
import { ArchivosSubidosService } from '../archivos-subidos/archivos-subidos.service';

@Component({
    selector: 'cargar-archivos',
    templateUrl: 'cargar-archivos.component.html',
    imports:[
        CommonModule, MatButtonModule, MatIconModule
    ]
})

export class CargarArchivosComponent implements OnInit {
    @Input() Uuid:string
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    uu_id:string

    constructor(
      private detalleTareaService:DetalleTareaService,
      private archivosService:ArchivosSubidosService,
      private route:ActivatedRoute,
      private utileSevice:UtilsService
    ) { 
      this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
      console.log(this.uu_id)
    }

    ngOnInit() {
      
    }

    uploadImage() {
        this.fileInput.nativeElement.click();
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
        this.handleFiles(input.files);
          input.value = '';
        }
    }

    handleFiles(files: FileList) {
      const formData = new FormData();
    
      Array.from(files).forEach(file => {
        formData.append('files', file);
      });

      this.detalleTareaService.postDocumentosGestion(formData, this.Uuid)
      .then(response=>{
        this.utileSevice.openSuccessSnakBar('Documento guardado correctamente.')
        this.archivosService.getArchivosByEntity(this.Uuid)
      })

      // Mostrar el contenido del FormData en consola
      /* for (let pair of (formData as any).entries()) {
          console.log(`${pair[0]}:`, pair[1]);
        }*/
    }
}